import { render } from "./RefButton.vue?vue&type=template&id=5d115727&scoped=true&ts=true"
import script from "./RefButton.vue?vue&type=script&lang=ts"
export * from "./RefButton.vue?vue&type=script&lang=ts"

import "./RefButton.vue?vue&type=style&index=0&id=5d115727&lang=scss&scoped=true"

import exportComponent from "/builds/root/dev.front.widget/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d115727"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QAvatar});
